import styled from 'styled-components';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const TabsContainer = styled(Flex).attrs({ marginTop: 2 })`
  flex: 1;

  overflow: hidden;

  & > div {
    flex: 1;

    &,
    & > :not(div:first-of-type) {
      overflow: hidden;
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    & > div[aria-hidden='true'] {
      display: none;
    }
  }
`;

export const Container = styled(Flex).attrs({
  flexDirection: 'column',
  flex: 1,
})``;
